import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchCategoryProducts, fetchCategoryDetails } from "../../../api";
import Navbar from "../../components/navbar";
import ProductItem from "../../components/product/product_item";
import SubCategories from "../../components/category/sub_categories ";
import { useParams } from "react-router-dom";

const ProductsFilterPage = ({ match }) => {
    const dispatch = useDispatch();
    const params = useParams();
    const [categoryProducts, setProducts] = useState();
    const [category, setCategory] = useState();
    const [formValues, setFormValues] = useState({});
    const limit = 20;
    const [offset, setOffset] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const fetchCategory = async (searchAttributes = {}) => {
        setIsLoading(true);
        const category = await fetchCategoryDetails(params.id);
        const products = await fetchCategoryProducts(params.id, searchAttributes ?? {});
        console.log('attr', searchAttributes);
        console.log('category products',products)
        if (products != null) {
            setCategory(category);
            setProducts(products);
            // dispatch(setPr);
            setOffset(offset + limit);
            document.title = "Поиск по категории: " + category.name;
        }
        setIsLoading(false);
    };

    const fetchProducts = async () => {
        setIsLoading(true);
        formValues['offset'] = offset;
        let prods = categoryProducts.concat(await fetchCategoryProducts(formValues));
        if (prods != null) {
            dispatch(setProducts(prods));
            setOffset(offset + limit);
        }
        setIsLoading(false);
    };
    useEffect(() => {
        fetchCategory();
    }, []);

    return (
        <>
            {/* Top Spacing */}
            <div className="pt-4 px-4">
                {/* Breadcrumb / Category Name */}
                {category && (
                    <div className="flex items-center gap-2 mb-2">
                        <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow-md shadow-blue-500/20">
                            <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                            </svg>
                        </div>
                        <div>
                            <h1 className="text-xl font-bold text-slate-800">{category?.name}</h1>
                            <p className="text-xs text-slate-400">
                                {categoryProducts?.length || 0} объявлений найдено
                            </p>
                        </div>
                    </div>
                )}
            </div>

            {/* SubCategories / Filters */}
            <SubCategories
                category={category}
                onSubmit={(form) => {
                    const values = { 'filter_attributes': form.getFieldsValue() };
                    console.log(values);
                    setFormValues(values);
                    fetchCategory(values);
                }}
            />

            {/* Loading State */}
            {isLoading && !categoryProducts?.length ? (
                <div className="flex flex-col items-center justify-center py-16">
                    <div className="w-12 h-12 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
                    <p className="mt-4 text-sm text-slate-400 font-medium">Загрузка объявлений...</p>
                </div>
            ) : (
                <div className="px-4 pt-2 pb-8">
                    {/* Section Header */}
                    <div className="flex items-center justify-between mb-4">
                        <h2 className="text-lg font-bold text-slate-700 flex items-center gap-2">
                            <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                            </svg>
                            Объявления
                        </h2>
                        {categoryProducts?.length > 0 && (
                            <span className="text-xs text-slate-400 bg-slate-50 px-3 py-1 rounded-full border border-slate-100">
                                {categoryProducts.length} шт.
                            </span>
                        )}
                    </div>

                    {/* Empty State */}
                    {(!categoryProducts?.length) ? (
                        <div className="bg-white border border-slate-100 rounded-2xl p-12 text-center shadow-sm">
                            <div className="w-16 h-16 mx-auto mb-4 bg-slate-50 rounded-2xl flex items-center justify-center">
                                <svg className="w-8 h-8 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                                </svg>
                            </div>
                            <h3 className="text-base font-semibold text-slate-700 mb-1">Нет объявлений</h3>
                            <p className="text-sm text-slate-400">Попробуйте изменить параметры поиска</p>
                        </div>
                    ) : (
                        /* Products Grid */
                        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
                            {categoryProducts.map((product) => (
                                <div key={product.id}>
                                    <ProductItem product={product} />
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Load More Button */}
                    {categoryProducts?.length > 0 && (
                        <div className="flex justify-center pt-8">
                            <button
                                onClick={() => fetchProducts()}
                                disabled={isLoading}
                                className="group px-8 py-3 bg-white border-2 border-slate-200 hover:border-blue-400 text-slate-600 hover:text-blue-600 font-semibold text-sm rounded-xl transition-all duration-200 hover:shadow-lg hover:shadow-blue-500/10 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                            >
                                {isLoading ? (
                                    <>
                                        <div className="w-4 h-4 border-2 border-slate-300 border-t-blue-500 rounded-full animate-spin"></div>
                                        Загрузка...
                                    </>
                                ) : (
                                    <>
                                        <svg className="w-4 h-4 group-hover:translate-y-0.5 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                                        </svg>
                                        Показать ещё
                                    </>
                                )}
                            </button>
                        </div>
                    )}
                </div>
            )}
        </>
    );
}

export default ProductsFilterPage;